<template>
  <div class="topicMore">
    <Header></Header>
    <Nav type="7"></Nav>
    <Toptitle title="驿声影"></Toptitle>
    <div class="back_a">
      <span @click="$router.back(-1)"><img src="../assets/static/images/back.png" />返回专辑列表</span>
    </div>
    <div class="album_main">
      <div class="album_left">
        <div class="album_left_main">
          <div class="album_left_main_top">
            <div class="album_cover">
            <img :src="albumList.logo">
          </div>
           <div class="album_right">
              <div class="album_name">{{albumList.title}}</div>
              <div class="album_subname">{{albumList.subtitle}}</div>
              <div class="aplayer_div">
                <aplayer @changeON="changeON" @onSuspend="onError"  :audio="audio"  ref="aplayer"/>
              </div>
              <!-- <div class="disc_songs">
                <div class="table idle">
                  <div class="table_container">
                    <table>
                      <thead>
                        <tr>
                          <th class="th_index" style="width: 10%;">{{num}}首</th>
                          <th class="th_song" style="width: 22.5%;">歌曲</th>
                          <th class="th_artist" style="width: 22.5%;">歌手</th>
                          <th class="th_introduce td_show550" style="width: 22.5%;">作曲</th>
                          <th class="th_duration" style="width: 22.5%;">时长</th>
                        </tr>
                      </thead>
                      <tbody></tbody>
                    </table>
                  </div>
                </div>
                <div class="disc">
                  <div class="table idle song_table">
                    <div class="table_container">
                      <table>
                        <thead>
                          <tr>
                            <th class="th_index" style="width: 10%;"></th>
                            <th class="th_song" style="width: 22.5%;"></th>
                            <th class="th_artist" style="width: 22.5%;"></th>
                            <th class="th_introduce td_show550" style="width: 22.5%;"></th>
                            <th class="th_duration" style="width: 22.5%;"></th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr :class="(index+1)%2==0?'odd':'even'" v-for="(item,index) in musicsList" :key="index">
                            <td>
                              <div class="index_container">
                                <span class="em index">{{index+1}}</span>
                                <div class="audio_icon unselectable"></div>
                                <div class="iconfont play_btn"></div>
                              </div>
                            </td>
                            <td>
                              <div class="td_container song_container" @click="goSoundDetail(item.id)">{{item.name}}</div>
                            </td>
                            <td>
                              <div class="td_container">{{item.singer}}</div>
                            </td>
                            <td  class="td_show550">
                              <div class="td_container">{{item.writewords}}</div>
                            </td>
                            <td>
                              <div class="td_container">{{item.timmer}}</div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div> -->
           </div>
          </div>
          <div class="album_introduce">
            <div class="album_title">专辑介绍</div>
            <div class="album_intro_details" v-html="albumList.introduce"></div>
          </div>
        </div>
      </div>
     
    </div>
    
    <Footer></Footer>
  </div>
</template>

<script>
  import Header from './common/Header.vue'
  import Nav from './common/Nav.vue'
  import Footer from './common/Footer.vue'
  import Toptitle from './common/Toptitle.vue'
  import { APlayer } from '@moefe/vue-aplayer';
  import bus from '../assets/static/bus';
  export default {
    data() {
      return {
        id:'',
        albumList:[],
        num:'',
        musicsList:[],
        audio: [],
      }
    },
    components: {
      Header,
      Footer,
      Nav,
      Toptitle,
      APlayer
    },
    created() {
      bus.$on('paychange', msg => {
        if(msg){
          this.$refs.aplayer.pause()
        }
      })
    },
    methods: {
      onError(e){
        console.log(e);
      },
      changeON(item,index){
        // console.log('88888:'+index);
        // console.log(item);
        if(index !=""){
          this.$router.push({
            name:'soundDetail',
            query:{
              id:item.id
            }
          })
        }
        
      },
      getAlbumList(){
        this.axios.post('api/m_issuemag/getDetail.do',this.qs({id:this.id})).then(res=>{
          if(res.status==200){
            this.albumList = res.data.data
            this.num = res.data.data.musics.length
            this.musicsList = res.data.data.musics
            console.log(this.musicsList)
            this.audio = []
            this.musicsList.sort((a,b)=>{return a.sortnum-b.sortnum})
            for(let item of this.musicsList){
              let obj ={
                id:item.id,
                name: item.name,
                artist: item.singer,
                url: item.musicaddr,
                cover: item.picture, 
                lrc:''
              }
              this.audio.push(obj)              
            }
          }
        })
      },
      goSoundDetail(id){
        this.$router.push({
          name:'soundDetail',
          query:{
            id:id
          }
        })
      }
    },
    mounted() {
     if(this.$route.query.id){
        this.id = this.$route.query.id
        this.getAlbumList()
     }
    },
    activated(){
      console.log(this.id != this.$route.query.id);
      if(this.id != this.$route.query.id){
         this.id = this.$route.query.id
         this.getAlbumList()
      }
    },
    beforeRouteLeave (to, from, next) {
        // console.log(to);
        // if(to.name != 'soundDetail'){
        //   to.meta.keepAlive = true
        // }
        // console.log(to);
        next()
    }
  }
</script>

<style>
.album_left{width: 100%;}
.aplayer_div{margin: 20px 0 0px;}
.aplayer .aplayer-info .aplayer-controller .aplayer-time{display: flex!important;}
.aplayer .aplayer-icon-back, .aplayer .aplayer-icon-forward, .aplayer .aplayer-icon-play{display: block!important;}
.aplayer-play-icon{display: flex;justify-content: flex-start;align-items: center;}
.aplayer-play-icon::after{content: '';background: url("../assets/static/images/pay.png");width: 20px;height:20px;display:inline-block;background-size: 100%;}
.aplayer-list-a{display: flex;align-items: center;justify-content:space-between;}
.divG{display: flex;align-items: center;justify-content:flex-start;}
.aplayer-list-title.aplayer-list-title-a{text-decoration:underline}
.album_left_main_top{display: flex;justify-content: flex-start;align-items: flex-start}
.album_subname{padding-left: 10px;}
.album_name{margin-top: 0;}
.back_a span{display: flex;justify-content: flex-start;align-items: center;margin-top: 20px;cursor: pointer;color: brown;}
.back_a img{height: 20px;margin-right: 5px;}
.aplayer-list{}
.aplayer-list::before{content: "";display: block;height: 20px;}
.album_introduce{margin-top:30px;}
.render-pay-icon{display: block!important;}
</style>

